module.exports = __webpack_public_path__ + "img/blank.96857d20.svg";